import React, { FC, useEffect } from 'react'

import { styled } from '@mui/system'
import { ObjectTypeEnum } from '../../../types/SubCondition'
import { FIELD_STATEMENT_OPERATORS } from '../../../context/CustomField/CustomFieldTypes'
import { ValueError } from '../../../store/groupConditionsSlice'
import { TextField } from '@mui/material'
import { useLocalizedText } from '../../../context/Localization/localizationHooks'
import { LocalizedText } from '../../../context/Localization/LocalizationTypes'
import { useViewModeReadOnly } from '../../../context/ViewMode/viewModeHooks'
import NumberField from './NumberField'

const RootCurrencyStatement = styled('div')(() => ({
    height: '40px',
    display: 'flex',
    alignItems: 'center',
}))
const SpanOverride = styled('span')(() => ({
    color: '#263238', 
    fontWeight: 600, 
    fontSize: 16, 
    fontFamily: 'Open Sans',
    margin: '0px 8px',
}))
export interface CurrencyStatementProps {
    operator: typeof FIELD_STATEMENT_OPERATORS['Currency'][number]['key']
    objectType: ObjectTypeEnum
    values: Array<string>
    valueError: ValueError
    onChange: (newValues: Array<string>) => void
}
const CurrencyStatement: FC<CurrencyStatementProps> = (props) => {
    const AndLabel = useLocalizedText(LocalizedText.AndLabel)

    const isReadOnly = useViewModeReadOnly()

    useEffect(() => {
        if (props.operator === 'EQUALS' || props.operator === 'GREATER_THAN' || props.operator === 'LESS_THAN' || props.operator === 'NOT_EQUALS') {
            props.onChange([props.values[0] || ''])
        } else if (props.operator === 'BETWEEN' || props.operator === 'NOT_BETWEEN') {
            // if second > first return second, if second <= first return first + 1
            const firstValue = Math.max(Number(props.values[0]), 0)
            const secondValue = Number(props.values[1]) > firstValue ? props.values[1] : String(firstValue + 1)
            props.onChange([String(firstValue) || '', secondValue || ''])
        }
    }, [props.operator])

    const currencyOneError = props.valueError && props.valueError.errors.findIndex(error => error.valueIndex === 0 && error.message) !== -1
    const currencyTwoError = props.valueError && props.valueError.errors.findIndex(error => error.valueIndex === 1 && error.message) !== -1

    return (
        <RootCurrencyStatement>
            {
                (props.operator === 'EQUALS' || props.operator === 'GREATER_THAN' || props.operator === 'LESS_THAN' || props.operator === 'NOT_EQUALS') && (
                    <NumberField 
                        value={props.values[0] || ''}
                        onChange={(value) => {
                            props.onChange([String(value)])
                        }}
                        error={currencyOneError}
                        disabled={isReadOnly}
                    />
                )
            }
            {
                (props.operator === 'BETWEEN' || props.operator === 'NOT_BETWEEN') && (
                    <>
                        <NumberField 
                            value={props.values[0] || ''}
                            onChange={(value) => {
                                const firstValue = Math.max(Number(value), 0)
                                const secondValue = Number(props.values[1]) > firstValue ? props.values[1] : String(firstValue + 1)

                                props.onChange([String(firstValue) || '', secondValue || ''])
                            }}
                            error={currencyOneError}
                            disabled={isReadOnly}
                        />
                        <SpanOverride>{AndLabel}</SpanOverride>
                        <NumberField 
                            value={props.values[1] || ''}
                            onChange={(value) => {
                                const firstValue = Math.max(Number(props.values[0] || ''), 0)
                                const realValue = Number(value || '')
                                const secondValue = realValue > firstValue ? realValue : firstValue + 1
                                props.onChange([ props.values[0] || '', String(secondValue) || ''])
                            }}
                            min={Number(props.values[0] || '') + 1}
                            error={currencyTwoError}
                            disabled={!props.values[0] || isReadOnly}
                        />
                    </>
                )
            }
        </RootCurrencyStatement>
    )
}

export default CurrencyStatement